module.exports = __webpack_public_path__ + "static/media/profile-user.7cc9a685.svg";